// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__72BIo","imageUploader":"EGiftCard_imageUploader__Ap-hM"};